module.exports = "<div *ngIf=\"visible\">\n  {{notFoundMessage}}\n  <a [routerLink]=\"resetLinkRoute\">{{resetLinkText}}</a>\n</div>\n"